/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route, Router } from "@angular/router";

import { Observable, of, timer } from "rxjs";
import { switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AppCustomPreloader implements PreloadingStrategy {
  constructor(private router: Router) {}

  preload(route: Route, load: Function): Observable<any> {
    return of(null);
  }
}
